<template>
  <v-fade-transition>
    <div
      v-show="bottomSheets.length > 0"
      style="max-height: 400px;"
      v-resize="onResize"
      ref="bottomTabs"
    >
      <v-layout
        align-start
        justify-start
        column
        fill-height
        style="margin: 0px;"
      >
        <v-tabs
          style="width: 100%; overflow-y: none; z-index: 10"
          v-model="active"
          color="grey darken-2"
          dark
          slider-color="primary"
        >
          <v-tab
            v-for="(item, index) in bottomSheets"
            :key="index"
            ripple
            @click="show"
          >
            {{ item.useValueAsKey ? item.value : item.title }}
            <v-btn @click.stop="deleteTab(index)" icon>
              <v-icon small>close</v-icon>
            </v-btn>
          </v-tab>
          <v-tab-item
            v-for="(bottomSheet, sheetIndex) in bottomSheets"
            :key="sheetIndex"
          >
            <layer-table
              v-if="bottomSheet.type == 'featureTable'"
              v-show="showTabs"
              :layer="bottomSheet"
              :is-table="bottomSheet.isTable"
            ></layer-table>

            <analysis-consequence-factors
              v-if="bottomSheet.type == 'consequenceFactorAnalysis'"
              :polygon-geometry="bottomSheet.polygonGeometry"
            />

            <analysis-arealplan-innspill
              v-if="bottomSheet.type == 'arealplanAnalysis'"
              :polygon-geometry="bottomSheet.polygonGeometry"
            />
          </v-tab-item>
          <v-spacer></v-spacer>
          <v-btn @click="showHide" icon>
            <v-icon>{{ showTabs ? "expand_more" : "expand_less" }}</v-icon>
          </v-btn>
        </v-tabs>
      </v-layout>
    </div>
  </v-fade-transition>
</template>

<script>
import LayerTable from "@/pages/MapPage/Tools/Layers/LayerTable";
import { mapState, mapActions } from "vuex";
export default {
  name: "TheBottomTabs",
  data() {
    return {
      active: null,
      windowSize: {
        x: 0,
        y: 0,
      },
    };
  },
  watch: {
    tabsHiddenSplitPaneHeight: function(newVal) {
      if (!this.showTabs && this.bottomSheets.length > 0) {
        this.setBottomTabsHeight(newVal + 0.5);
        this.setMapHeight(100 - (newVal + 0.0));
      }
    },
    bottomSheets: {
      handler: function(newVal) {
        this.active = newVal.length - 1;
      },
      deep: true,
    },
  },
  computed: {
    ...mapState(["showTabs", "bottomTabsHeight", "mapHeight", "bottomSheets"]),
    tabsHiddenSplitPaneHeight() {
      this.showTabs;
      return 48 / (this.windowSize.y / 100);
    },
  },
  components: {
    LayerTable,
    AnalysisConsequenceFactors: () =>
      import("@/pages/MapPage/Tools/Analysis/AnalysisConsequenceFactors"),
    AnalysisArealplanInnspill: () =>
      import("@/pages/MapPage/Tools/Analysis/AnalysisArealplanInnspill"),
  },
  methods: {
    ...mapActions([
      "setBottomTabsHeight",
      "setMapHeight",
      "setShowTabs",
      "removeFeatureTable",
    ]),
    onResize() {
      this.windowSize = { x: window.innerWidth, y: window.innerHeight };
    },
    showHide() {
      this.setBottomTabsHeight(this.tabsHiddenSplitPaneHeight + 0.5);
      this.setMapHeight(100 - (this.tabsHiddenSplitPaneHeight + 0.0));
      this.setShowTabs(!this.showTabs);
      this.onResize();
    },
    show() {
      this.setShowTabs(true);
    },
    next() {
      const active = parseInt(this.active);
      this.active = active < 2 ? active + 1 : 0;
    },
    deleteTab(index) {
      if (this.active > 0) {
        this.active = this.active - 1;
      } else {
        this.active = this.active + 1;
      }
      this.removeFeatureTable(index);
      if (this.bottomSheets.length == 0) {
        this.setShowTabs(false);
        this.setMapHeight(100);
      }
    },
  },
  mounted() {
    this.onResize();
  },
};
</script>

<style></style>
